<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Boletos Garantidos</b>
            </h3>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-sm-8">
                <div class="form-group">
                  <label for="empresa">Loja</label>
                  <v-select v-model="empresaSelecionada" :options="empresas" placeholder="TODAS"></v-select>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="empresa">Situação</label>
                  <select class="form-control" v-model="dados.situacao">
                    <option value>TODAS</option>
                    <option value="GARANTIDO">GARANTIDO</option>
                    <option value="ENVIADO PARA REGISTRO">ENVIADO PARA REGISTRO</option>
                    <option value="DISPONÍVEL PARA PAGAMENTO">DISPONÍVEL PARA PAGAMENTO</option>
                    <option value="ENVIADO PARA BAIXA">ENVIADO PARA BAIXA</option>
                    <option value="ENVIADO PARA CANCELAMENTO">ENVIADO PARA CANCELAMENTO</option>
                    <option value="ENVIADO PARA REMOÇÃO">ENVIADO PARA REMOÇÃO</option>
                    <option value="BAIXADO">BAIXADO</option>
                    <option value="BAIXADO (CANCELADO)">BAIXADO (CANCELADO)</option>
                    <option value="BAIXADO (REMOVIDO)">BAIXADO (REMOVIDO)</option>
                    <option value="LIQUIDADO">LIQUIDADO</option>
                    <option value="QUITADO">QUITADO</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-10">
                <input
                  style="width: 100%"
                  class="form-control"
                  placeholder="Busca: Entre com o NOME ou DOCUMENTO do cliente e pressione enter"
                  name="filtro_pesquisa"
                  ref="filtro_pesquisa"
                  type="text"
                  v-model="dados.pesquisa"
                  @keyup.enter="getDataTable"
                />
              </div>
              <div class="col-md-2">
                <button @click="getDataTable" class="btn btn-default btn-block"><i class="fa fa-filter"></i> Filtrar</button>
              </div>
            </div>
            <div class="row" style="margin-top:15px">
              <div class="col-sm-12 table-responsive">
                <table
                  aria-describedby="example1_info"
                  role="grid"
                  id="example1"
                  class="table table-bordered table-striped"
                >
                  <thead>
                    <tr role="row">
                      <th style="width: 10%">Garantia</th>
                      <th style="width: 15%">Loja</th>
                      <th style="width: 16%">Cliente</th>
                      <th style="width: 12%">CPF/CNPJ</th>
                      <th style="width: 10%">Vencimento</th>
                      <th style="width: 11%">Valor</th>
                      <th style="width: 8%">Situação</th>
                      <th style="width: 8%">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="even" role="row" v-for="item in apiData.data" :key="item.id">
                      <td>{{ item.id }} - {{ item.digito }}</td>
                      <td>{{ item.garantia.usuario.empresa.fantasia }}</td>
                      <td>{{ item.garantia.pessoa.nome_razao }}</td>
                      <td>{{ item.garantia.pessoa.cpf_cnpj }}</td>
                      <td>{{ item.vencimento | dataFormatada }}</td>
                      <td>{{ item.valor_garantido | numberFormat(2, ',', '.') }}</td>
                      <td>{{ item.situacao }}</td>
                      <td>
                        <!--
                        <button
                          class="btn btn-success btn-sm"
                          @click="receber(item.id)"
                          title="Receber"
                        >
                          <i class="fa fa-fw fa-thumbs-up"></i>
                        </button>
                        -->

                        	<!--
                          <button class="btn btn-warning btn-sm" @click="getDuplicata(boleto.id)" title="Imprimir Duplicata">
                            <i class="fa fa-fw fa-list"></i>
                          </button>
                          -->

                          <button  @click="quitar(item.id)" v-if="item.situacao === 'BAIXADO (REMOVIDO)'" class="btn btn-success btn-sm" title="Marcar como quitado">
                            <i class="fa fa-fw fa-thumbs-up"></i>
                          </button>


                          <button
                            class="btn btn-info btn-sm"
                            @click="getBoleto(item.id)"
                            title="Gerar Boleto"
                          >
													<i class="fa fa-fw fa-barcode"></i>
												</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="row">
                  <div
                    class="col-sm-5"
                  >Mostrando {{ this.apiData.from }} até {{ this.apiData.to }} de {{ this.apiData.total }} registros encontrados.</div>
                  <div class="col-sm-7" style="text-align:right">
                    <laravue-pagination :limit="5" :data="apiData" v-on:pagination-change-page="getDataTable">
                      <span slot="prev-nav">&lt; Anterior</span>
                      <span slot="next-nav">Próximo &gt;</span>
                    </laravue-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </div>
      <!-- /.col-md-12 -->
    </div>
    <!-- /.row -->
  </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
import vSelect from "vue-select";
export default {
  data: () => ({
    empresas: [],
    empresaSelecionada: null,
    dados: {
      pesquisa: "",
      situacao: '',
      empresa_id: ''
    },
    apiData: {
      data: []
    }
  }),
  mounted() {
    this.getDataTable();
    this.getEmpresas();
    this.$nextTick(() => {
      this.$refs.filtro_pesquisa.focus();
    });
  },

  methods: {
    getEmpresas() {
      axios
        .get(
          `${this.$store.state.serverURI}/api/empresa/dataForSelect`,
          this.$store.getters.getHeaderAuth
        )
        .then(response => {
          console.log(response.data);
          this.empresas = response.data;
        });
    },
    quitar(boletoId) {
      this.$swal({
        title: "Confirma quitação do boleto selecionado?",
        text: "Voce não poderá reverter essa operação!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sim, confirmo!"
      }).then(result => {
        if (result.value) {
          axios
            .post(
              `${this.$store.state.serverURI}/api/boleto/quitar/${boletoId}`,
              {},
              this.$store.getters.getHeaderAuth
            )
            .then(response => {
              this.$swal({
                type: response.data.status == 200 ? "success" : "error",
                title:
                  response.data.status == 200
                    ? "Tudo Certo!"
                    : "Ops! Ocorreu um erro.",
                text: response.data.msg,
                showConfirmButton: false,
                timer: 1500
              });
              this.getDataTable();
            })
            .catch(erro => {
              this.$swal({
                type: "error",
                title: "Ops! Ocorreu um erro.",
                text: erro,
                showConfirmButton: true
              });
            });
        }
      });
    },
    getDataTable(page) {
      if (typeof page === "undefined") {
        page = 1;
      }
      this.dados.page = page;
      let config = this.$store.getters.getHeaderAuth;
      config.params = this.dados;
      axios
        .get(`${this.$store.state.serverURI}/api/boleto/getAllPaginate`, config)
        .then(response => {
          this.apiData = response.data;
        })
        .catch(error => {
          this.$store.commit("throwException", error);
        });
    },
    getBoleto(boletoId) {
			window.open(
				`${this.$store.state.serverURI}/api/boleto/getBoleto/${boletoId}`,
				"_blank"
			);
		},
  },
  watch: {
    page: function(val) {
      this.getDataTable();
    },
     empresaSelecionada: function(val) {
       if (val) {
         this.dados.empresa_id = val.value;
       } else {
         this.dados.empresa_id = '';
       }
        
    }
  },

  components: {
    vSelect
  }
};
</script>
<style>
td {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// index.vue?590ee584